module.exports = __webpack_public_path__ + "img/wordFour.2013843d.png";